require('./brokerStocksPurchaseOrderView.scss');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const BrokerStocksPurchaseOrderWizard = require('components/broker/brokerStocksPurchaseOrder/brokerStocksPurchaseOrderWizard');
const BrokerStocksPurchaseOrderSuccess = require('components/broker/brokerStocksPurchaseOrder/brokerStocksPurchaseOrderSuccess/brokerStocksPurchaseOrderSuccess');
const BrokerStocksPurchaseOrderSidebar = require('components/broker/brokerStocksPurchaseOrder/brokerStocksPurchaseOrderSidebar/brokerStocksPurchaseOrderSidebar');
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @helpers
const { formatText, FormattedText, getFinalTitle } = require('core/i18n').i18n;
const { getDocumentURL } = require('utilities/stringHelper');

// @actions
const BrokerStocksPurchaseOrderActions = require('actions/brokerStocksPurchaseOrder');
const productFileActions = require('actions/brokerGetProductFile');

// @constants
const {
    MYPROFILE_BROKER_URL,
    BROKER_CORPORATE_OPERATIONS_URL,
    BROKER_MIFID_VERSION_2,
    BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PRODUCT_TYPE,
    BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL,
    BROKER_CONVENIENCE_MIFID_EMPTY_EVENT_CODE,
    BROKER_CONVENIENCE_MIFID_EMPTY_FEE_NUMBERS,
    BROKER_BUY_SCREEN
} = require('constants/index');

class BrokerStocksPurchaseOrderView extends React.Component {

    componentWillMount() {
        const { immBrokerStocksPurchaseOrder, getProductFile, history } = this.props;
            const immOperation = immBrokerStocksPurchaseOrder.get('operation');
            const isLoaded = immBrokerStocksPurchaseOrder.get('isLoaded');

            if (!isLoaded) {
                history.push(BROKER_CORPORATE_OPERATIONS_URL);
            } else if(immOperation) {
                const isin = immOperation.get('isin');
                const iso = immOperation.get('iso');
                getProductFile(isin, iso, BROKER_BUY_SCREEN);
            }
    }

    buildSideColumn() {
        const { immBrokerStocksPurchaseOrder } = this.props;

        return (
            <BrokerStocksPurchaseOrderSidebar
                immBrokerStocksPurchaseOrder={immBrokerStocksPurchaseOrder}
            />
        );
    }

    buildSuccess() {
        const { immBrokerStocksPurchaseOrder } = this.props;

        return (
            <BrokerStocksPurchaseOrderSuccess
                immBrokerStocksPurchaseOrder={immBrokerStocksPurchaseOrder}
            />
        );
    }

    buildWizard() {
        const {
            immBrokerStocksPurchaseOrder,
            immSignaturePattern,
            onChangeAmount,
            onValidateStep,
            onSetVisibleStep,
            onChangeManifest,
            onFinish,
            setDocumentsRead
        } = this.props;

        return (
            <BrokerStocksPurchaseOrderWizard
                immBrokerStocksPurchaseOrder={immBrokerStocksPurchaseOrder}
                immSignaturePattern={immSignaturePattern}
                onChangeAmount={onChangeAmount}
                onValidateStep={onValidateStep}
                onSetVisibleStep={onSetVisibleStep}
                onChangeManifest={onChangeManifest}
                onFinish={onFinish}
                setDocumentsRead={setDocumentsRead}
            />
        );
    }

    render() {
        const { immBrokerStocksPurchaseOrder, immProductFile, immVariables } = this.props;
        const immOperation = immBrokerStocksPurchaseOrder.get('operation');
        const productName = trim(immProductFile.get('companyName'));
        const isin = immOperation.get('isin');
        const iso = immOperation.get('iso');
        const valueCode = immOperation.get('linkId') || undefined;
        const eventCode = BROKER_CONVENIENCE_MIFID_EMPTY_EVENT_CODE;
        const feeNumbers = BROKER_CONVENIENCE_MIFID_EMPTY_FEE_NUMBERS;
        const productUrl = `/myprofile/broker/productFile/${isin}/${iso}`;
        const continuationUrl = BROKER_CORPOTATE_OPERATIONS_PURCHASE_ORDER_URL;
        const mifidOptions = {
            hideAlreadyPerformTestResult: true,
            productType: BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PRODUCT_TYPE
        };
        const fees_url = getDocumentURL(immVariables.getIn(['variables', 'parameters', 'documents_urls', 'investments', 'wealth_rate']));
        const breadcrumb = [
            {
                text: formatText('broker-myWallet'),
                url: MYPROFILE_BROKER_URL
            },
            {
                text: formatText('stocksPurchaseOrder-corporateOperations'),
                url: '/myprofile/broker/corporatesOperations'
            },
            {
                text: formatText('stocksPurchaseOrder-opvStocksPurchase'),
                url: ''
            }
        ];
        let content;
        let commissionsButton;

        if (immBrokerStocksPurchaseOrder.get('finished')) {
            content = this.buildSuccess();
        } else {
            commissionsButton = (
                <OKButton
                    inverse={true}
                    modifier="ghost"
                    onClick={() => window.open(fees_url, '_blank')}
                >
                    <FormattedText value="stocksPurchaseOrder-commissions" />
                </OKButton>
            );

            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-8">
                        {this.buildWizard()}
                    </div>

                    <div className="col-xs-4">
                        {this.buildSideColumn()}
                    </div>
                </div>
            );
        }

        return (
            <BrokerMiFIDBehavior
                mifidVersion={BROKER_MIFID_VERSION_2}
                productName={productName}
                productUrl={productUrl}
                continuationUrl={continuationUrl}
                productIsinId={isin}
                productMarketId={iso}
                productMifidId={BROKER_CORPORATE_OPERATIONS_COMPRA_ACCIONES_PRODUCT_TYPE}
                valueCode={valueCode}
                eventCode={eventCode}
                feeNumbers={feeNumbers}
                mifidOptions={mifidOptions}
            >
                <section className="broker-stocks-purchase-order-view">
                    <OKCover size="medium" section="broker">
                        <OKHeaderSubPage
                            breadcrumbConfig={breadcrumb}
                            subtitleLeft={formatText('stocksPurchaseOrder-subtitle')}
                            isSubtitleLeftCapital={false}
                            finalTitle={getFinalTitle('stocksPurchaseOrder-title')}
                        >
                            {commissionsButton}
                        </OKHeaderSubPage>
                    </OKCover>
                    <section className={"broker-stocks-purchase-order-view__body"}>
                        {content}
                    </section>
                </section>
            </BrokerMiFIDBehavior>
        );
    }
}

BrokerStocksPurchaseOrderView.propTypes = {
    history: PropTypes.object.isRequired,
    immBrokerStocksPurchaseOrder: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immProductFile: PropTypes.object.isRequired,
    immVariables: PropTypes.object.isRequired,
    onChangeAmount: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onSetVisibleStep: PropTypes.func.isRequired,
    onChangeManifest: PropTypes.func.isRequired,
    onFinish: PropTypes.func.isRequired,
    getProductFile: PropTypes.func.isRequired,
    setDocumentsRead: PropTypes.func.isRequired,
};

module.exports.constructor = BrokerStocksPurchaseOrderView;
module.exports.BrokerStocksPurchaseOrderView = connect(
    (state) => ({
        immBrokerStocksPurchaseOrder: state.brokerStocksPurchaseOrder,
        immSignaturePattern: state.signaturePattern,
        immProductFile: state.brokerProductFile,
        immVariables: state.globalVariables
    }),
    {
        onChangeAmount: BrokerStocksPurchaseOrderActions.changeAmount,
        onValidateStep: BrokerStocksPurchaseOrderActions.validateStep,
        onSetVisibleStep: BrokerStocksPurchaseOrderActions.setStep,
        onChangeManifest: BrokerStocksPurchaseOrderActions.changeManifest,
        onFinish: BrokerStocksPurchaseOrderActions.finish,
        getProductFile: productFileActions.getProductFile,
        setDocumentsRead: BrokerStocksPurchaseOrderActions.setDocumentsRead
    }
)(withRouter(BrokerStocksPurchaseOrderView));
